export default [
    {
        path: '/',
        name: '',
        icon: 'el-icon-tickets',
        component: () => import(/* webpackChunkName: "home" */ '../views/home.vue'),
        hidden: true,
        children: [
            {path: "", redirect: '/account'},
        ]
    },
    {
        path: '/',
        name: '',
        icon: 'el-icon-tickets',
        component: () => import(/* webpackChunkName: "home" */ '../views/home.vue'),
        children:[
            {path:'/profile',component:() => import(/* webpackChunkName: "profile" */ '../views/profile'),name:'我的档案'}
        ]
    },
    {
        path: '/',
        name: '',
        icon: 'el-icon-s-goods',
        component: () => import(/* webpackChunkName: "home" */ '../views/home.vue'),
        children:[
            {path:'/account',component:() => import(/* webpackChunkName: "account" */ '../views/admin-account'),name:'账户管理',
                meta:{friendly:'账户',model:'ZoomAccount'}}
        ]
    },
    {
        path: '/',
        name: '',
        icon: 'el-icon-school',
        component: () => import(/* webpackChunkName: "home" */ '../views/home.vue'),
        children:[
            {path:'/organization',component:() => import(/* webpackChunkName: "organization" */ '../views/admin-admin'),name:'单位管理',
                meta:{friendly:'单位',model:'Organization'}}
        ]
    },
    {
        path: '/',
        name: '',
        icon: 'el-icon-house',
        component: () => import(/* webpackChunkName: "home" */ '../views/home.vue'),
        children:[
            {path:'/room',component:() => import(/* webpackChunkName: "room" */ '../views/admin-room'),name:'房间管理',
                meta:{friendly:'房间',model:'ZoomRoom'}}
        ]
    },
    {
        path: '/admin',
        name: '设置',
        icon: 'el-icon-setting',
        component: () => import(/* webpackChunkName: "home" */ '../views/home.vue'),
        meta:{},
        children:[
            {icon: 'el-icon-user',path:'/visitor',component:() => import(/* webpackChunkName: "visitors" */ '../views/admin-visitor'), name:'用户管理',meta:{friendly:'用户',model:'Visitor'}},
            {icon: 'el-icon-s-operation',path:'/parameters',component:() => import(/* webpackChunkName: "parameters" */ '../views/admin-admin'),name:'参数管理',meta:{friendly:'参数',model:'Parameter',copy:true}},
            {icon: 'el-icon-key',path:'/admin-syslog',component:() => import(/* webpackChunkName: "syslogs" */ '../views/admin-syslog'),name:'系统日志',meta:{friendly:'日志',model:'SysLog',}},
        ]
    },
    {
        path: '/',
        name: '监控',
        icon: 'el-icon-monitor',
        component: () => import(/* webpackChunkName: "home" */ '../views/home.vue'),
        meta:{},
        children:[
            {icon: 'el-icon-user',path:'/monitor',component:() => import(/* webpackChunkName: "monitor" */ '../views/admin-monitor'), name:'实时监控',},
        ]
    },
]
